import { GameManager } from "../GameManager";
import { Game } from "../Game";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { Scene } from "phaser";

export class BootScene extends Phaser.Scene {
  public static currentInstance: BootScene;
  static _isBrave: boolean = false;
  static _isWebKit: boolean = false;
  static textYgap: number = 0;
  static originY: number = .5;
  initiallyLandscape: boolean = false;

  public static onOrientationChange(): void {
    BootScene.currentInstance.time.addEvent({
      delay: 100,
      callback: () => {
        GameVars.scaleY = GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH / (window.innerHeight / window.innerWidth);
        Game.currentInstance.scale.refresh();
      },
      callbackScope: BootScene.currentInstance,
    });
  }

  constructor() {
    super("BootScene");
  }

  public preload(): void {
    this.load.image("bg_glow", "assets/bg_glow.png");
    this.load.image("bg_texture", "assets/bg_texture.png");
    //this.scene.scene.game.config.roundPixels = true;
  
      
  }
  public static isWebKit() {
    // Use any of the detection methods above
    return /safari|applewebkit/i.test(navigator.userAgent) && !/chrome|crios|chromium|edg|firefox|fxios|opera|opr/i.test(navigator.userAgent);
  }
  public create(): void {
    BootScene.isBrave();
    BootScene.currentInstance = this;
    GameManager.setCurrentScene(this);
    let isMobile: any = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i);

    if (isMobile) {
      // Use requestAnimationFrame instead of setInterval for better performance
      const checkOrientation = () => {
        this.checkOriention();
        requestAnimationFrame(checkOrientation);
      };
      requestAnimationFrame(checkOrientation);
    } else {
      window.addEventListener("resize", this.resize.bind(this), false);
    }

    window.focus();
    this.resize();

    window.focus();
    this.resize();
    // this.scene.setVisible(false);

    GameManager.init();
    if (GameVars.currentScene.sys.game.device.os.desktop) {
    } else {
      if (window.innerWidth > window.innerHeight) {
        GameVars.intitialised = false;
        // document.getElementById("orientation").style.display = "block";
        // document.getElementById("content").style.display = "none";
      } else {
        //GameManager.init();
      }
    }
  }

  private checkOriention(): void {
    const w = window.innerWidth;
    const h = window.innerHeight;

    if (w < h) {
      if (!GameVars.intitialised) {
        window.location.reload();
        console.log("RELOAD");
        GameVars.intitialised = true;
        // GameVars.currentScene.scene.start("PreloadScene");
        // GameManager.init();
      }

      document.getElementById("orientation").style.display = "none";
      document.getElementById("content").style.display = "block";
    } else {
      document.getElementById("orientation").style.display = "block";
      document.getElementById("content").style.display = "none";
    }
  }

  private resize(): void {
    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameWidth: any = GameConstants.GAME_WIDTH;
    const gameHeight: any = GameConstants.GAME_HEIGHT;

    const gameRatio = gameWidth / gameHeight;

    if (windowRatio < gameRatio) {
      canvas.style.width = windowWidth + "px";
      canvas.style.height = windowWidth / gameRatio + "px";
    } else {
      canvas.style.width = windowHeight * gameRatio + "px";
      canvas.style.height = windowHeight + "px";
    }
    // onOrientationChange(true);
  }

  public static isBrave(): boolean {
    const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    //@ts-ignore
    if (window.navigator.brave !== undefined) {
      console.log("brave object found*****");
      //@ts-ignore
      if (window.navigator.brave.isBrave.name === "isBrave" && !isMobile) {
        console.log("brave object found confirm");
        this._isBrave = true;
      
        this.textYgap = 1;
      }
    }

    if (BootScene.isWebKit()&& BootScene.isIOS18OrAbove()) {
      
        this.originY = 0.648;//0.66
     
      return this._isWebKit;
    }
    return this._isBrave;
  }
 public static isIOS18OrAbove() {
  const userAgent = navigator.userAgent;
  const match = userAgent.match(/OS (\d+)[._](\d+)?(?:[._](\d+))?/i);
  if (match && /iPad|iPhone|iPod/.test(userAgent)) {
    const major = parseInt(match[1], 10);
    
    return major >= 18;
  }
  return false;
}
}
